export enum DataScopeType {
  Customer = 1,
  Location = 2,
  Area = 3,
  Section = 4,
}

export enum DataScopeStatus {
  Ignored = -2,
  Disabled = -1,
  Setup = 0,
  Active = 1,
}

export interface IDataScope {
  id: number;
  isExecutive: boolean;
  type: DataScopeType;
  status: DataScopeStatus;
  name: string;
  children: ILocationScope[];
}

export interface ILocationScope extends IDataScope {
  currencyCode: string;
  currencySymbol: string;
}
